export default __webpack_public_path__ + "static/media/cssandhtml.13675869.png";